/* cspell:disable */
const currencyLocaleMap: Record<string, string> = {
  AED: "ar-AE", // United Arab Emirates Dirham
  AFN: "ps-AF", // Afghan Afghani
  ALL: "sq-AL", // Albanian Lek
  AMD: "hy-AM", // Armenian Dram
  ANG: "nl-CW", // Netherlands Antillean Guilder
  AOA: "pt-AO", // Angolan Kwanza
  ARS: "es-AR", // Argentine Peso
  AUD: "en-AU", // Australian Dollar
  AWG: "nl-AW", // Aruban Florin
  AZN: "az-AZ", // Azerbaijani Manat
  BAM: "bs-BA", // Bosnia and Herzegovina Convertible Mark
  BBD: "en-BB", // Barbadian Dollar
  BDT: "bn-BD", // Bangladeshi Taka
  BGN: "bg-BG", // Bulgarian Lev
  BHD: "ar-BH", // Bahraini Dinar
  BIF: "fr-BI", // Burundian Franc
  BMD: "en-BM", // Bermudian Dollar
  BND: "en-BN", // Brunei Dollar
  BOB: "es-BO", // Bolivian Boliviano
  BRL: "pt-BR", // Brazilian Real
  BSD: "en-BS", // Bahamian Dollar
  BTN: "dz-BT", // Bhutanese Ngultrum
  BWP: "en-BW", // Botswana Pula
  BYN: "be-BY", // Belarusian Ruble
  BZD: "en-BZ", // Belize Dollar
  CAD: "en-CA", // Canadian Dollar
  CDF: "fr-CD", // Congolese Franc
  CHF: "de-CH", // Swiss Franc
  CLP: "es-CL", // Chilean Peso
  CNY: "zh-CN", // Chinese Yuan
  COP: "es-CO", // Colombian Peso
  CRC: "es-CR", // Costa Rican Colón
  CUP: "es-CU", // Cuban Peso
  CVE: "pt-CV", // Cape Verdean Escudo
  CZK: "cs-CZ", // Czech Koruna
  DKK: "da-DK", // Danish Krone
  DOP: "es-DO", // Dominican Peso
  DZD: "ar-DZ", // Algerian Dinar
  EGP: "ar-EG", // Egyptian Pound
  ERN: "ti-ER", // Eritrean Nakfa
  ETB: "am-ET", // Ethiopian Birr
  EUR: "fr-FR", // Euro (general)
  FJD: "en-FJ", // Fijian Dollar
  FKP: "en-FK", // Falkland Islands Pound
  GBP: "en-GB", // British Pound Sterling
  GEL: "ka-GE", // Georgian Lari
  GHS: "ak-GH", // Ghanaian Cedi
  GIP: "en-GI", // Gibraltar Pound
  GMD: "en-GM", // Gambian Dalasi
  GNF: "fr-GN", // Guinean Franc
  GTQ: "es-GT", // Guatemalan Quetzal
  GYD: "en-GY", // Guyanese Dollar
  HKD: "zh-HK", // Hong Kong Dollar
  HNL: "es-HN", // Honduran Lempira
  HRK: "hr-HR", // Croatian Kuna
  HTG: "ht-HT", // Haitian Gourde
  HUF: "hu-HU", // Hungarian Forint
  IDR: "id-ID", // Indonesian Rupiah
  ILS: "he-IL", // Israeli New Shekel
  INR: "hi-IN", // Indian Rupee
  IQD: "ar-IQ", // Iraqi Dinar
  IRR: "fa-IR", // Iranian Rial
  ISK: "is-IS", // Icelandic Króna
  JMD: "en-JM", // Jamaican Dollar
  JPY: "ja-JP", // Japanese Yen
  KES: "sw-KE", // Kenyan Shilling
  KGS: "ky-KG", // Kyrgyzstani Som
  KHR: "km-KH", // Cambodian Riel
  KPW: "ko-KP", // North Korean Won
  KRW: "ko-KR", // South Korean Won
  KWD: "ar-KW", // Kuwaiti Dinar
  KYD: "en-KY", // Cayman Islands Dollar
  KZT: "kk-KZ", // Kazakhstani Tenge
  LAK: "lo-LA", // Laotian Kip
  LBP: "ar-LB", // Lebanese Pound
  LKR: "si-LK", // Sri Lankan Rupee
  LRD: "en-LR", // Liberian Dollar
  LSL: "en-LS", // Lesotho Loti
  LYD: "ar-LY", // Libyan Dinar
  MAD: "ar-MA", // Moroccan Dirham
  MDL: "ro-MD", // Moldovan Leu
  MGA: "mg-MG", // Malagasy Ariary
  MKD: "mk-MK", // Macedonian Denar
  MMK: "my-MM", // Myanmar Kyat
  MNT: "mn-MN", // Mongolian Tögrög
  MOP: "pt-MO", // Macanese Pataca
  MRU: "ar-MR", // Mauritanian Ouguiya
  MUR: "en-MU", // Mauritian Rupee
  MVR: "dv-MV", // Maldivian Rufiyaa
  MWK: "ny-MW", // Malawian Kwacha
  MXN: "es-MX", // Mexican Peso
  MYR: "ms-MY", // Malaysian Ringgit
  MZN: "pt-MZ", // Mozambican Metical
  NAD: "en-NA", // Namibian Dollar
  NGN: "en-NG", // Nigerian Naira
  NOK: "no-NO", // Norwegian Krone
  NPR: "ne-NP", // Nepalese Rupee
  NZD: "en-NZ", // New Zealand Dollar
  OMR: "ar-OM", // Omani Rial
  PAB: "es-PA", // Panamanian Balboa
  PEN: "es-PE", // Peruvian Sol
  PGK: "en-PG", // Papua New Guinean Kina
  PHP: "en-PH", // Philippine Peso
  PKR: "ur-PK", // Pakistani Rupee
  PLN: "pl-PL", // Polish Zloty
  PYG: "es-PY", // Paraguayan Guarani
  QAR: "ar-QA", // Qatari Rial
  RON: "ro-RO", // Romanian Leu
  RSD: "sr-RS", // Serbian Dinar
  RUB: "ru-RU", // Russian Ruble
  RWF: "rw-RW", // Rwandan Franc
  SAR: "ar-SA", // Saudi Riyal
  SBD: "en-SB", // Solomon Islands Dollar
  SCR: "en-SC", // Seychellois Rupee
  SDG: "ar-SD", // Sudanese Pound
  SEK: "sv-SE", // Swedish Krona
  SGD: "en-SG", // Singapore Dollar
  SHP: "en-SH", // Saint Helena Pound
  SLL: "en-SL", // Sierra Leonean Leone
  SOS: "so-SO", // Somali Shilling
  SRD: "nl-SR", // Surinamese Dollar
  SSP: "en-SS", // South Sudanese Pound
  STN: "pt-ST", // São Tomé and Príncipe Dobra
  SVC: "es-SV", // Salvadoran Colón
  SZL: "en-SZ", // Swazi Lilangeni
  THB: "th-TH", // Thai Baht
  TJS: "tg-TJ", // Tajikistani Somoni
  TMT: "tk-TM", // Turkmenistani Manat
  TND: "ar-TN", // Tunisian Dinar
  TOP: "en-TO", // Tongan Paʻanga
  TRY: "tr-TR", // Turkish Lira
  TTD: "en-TT", // Trinidad and Tobago Dollar
  TWD: "zh-TW", // New Taiwan Dollar
  TZS: "sw-TZ", // Tanzanian Shilling
  UAH: "uk-UA", // Ukrainian Hryvnia
  UGX: "en-UG", // Ugandan Shilling
  USD: "en-US", // United States Dollar
  UYU: "es-UY", // Uruguayan Peso
  UZS: "uz-UZ", // Uzbekistani Som
  VEF: "es-VE", // Venezuelan Bolívar
  VND: "vi-VN", // Vietnamese Dong
  VUV: "bi-VU", // Vanuatu Vatu
  WST: "sm-WS", // Samoan Tala
  XAF: "fr-CM", // Central African CFA Franc
  XCD: "en-AG", // East Caribbean Dollar
  XOF: "fr-BJ", // West African CFA Franc
  XPF: "fr-PF", // CFP Franc
  YER: "ar-YE", // Yemeni Rial
  ZAR: "en-ZA", // South African Rand
  ZMW: "en-ZM", // Zambian Kwacha
  ZWL: "en-ZW", // Zimbabwean Dollar
};

const defaultFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export const getFormatterForCurrency = (
  currency?: string | null
): Intl.NumberFormat => {
  if (!currency) return defaultFormatter;

  const locale = currencyLocaleMap[currency];
  if (!locale) return defaultFormatter;

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
};
